import styled from 'styled-components';
import { FileSelector } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';

export const ActionButton = styled(ButtonIcon)`
    width: 3rem;
    height: 3rem;
    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;

export const ModalContent = styled.div`
    padding: 0.5rem 0 1rem;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
`;

export const StyledFileSelector = styled(FileSelector)`
    width: 100%;
`;
